import { showHttpError, showSuccess } from '@calendly/alert'
import { httpRequest } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { startSubmitting, stopSubmitting, closePopup } from 'actions/integrations/disconnect_popup'
import { redirectToAuthorizeUrl } from 'actions/omniauth'

export const fetchAccount = createAsyncThunk(
  'integrations/webex/fetchAccount',
  async (_, { rejectWithValue }) => {
    const [success, data] = await httpRequest({
      url: '/api/integrations/webex/account',
      method: 'GET'
    })

    if (!success) {
      return rejectWithValue()
    }

    return data
  }
)

export const connectAccount = () => async (dispatch) => {
  dispatch(redirectToAuthorizeUrl('/users/auth/webex'))
}

export const disconnectAccount = createAsyncThunk(
  'integrations/webex/disconnectAccount',
  async ({ reconnect = false }, { dispatch }) => {
    dispatch(startSubmitting())
    const [success, data] = await httpRequest({
      url: '/api/integrations/webex/account',
      method: 'DELETE'
    })

    dispatch(stopSubmitting())
    dispatch(closePopup())

    if (success) {
      if (reconnect) {
        dispatch(redirectToAuthorizeUrl('/users/auth/webex'))
      } else {
        dispatch(showSuccess(I18n.t('publisher.integrations.webex.disconnect_success_notice')))
      }
    } else {
      dispatch(showHttpError(data))
    }
  }
)

export const { reducer } = createSlice({
  name: 'webex',
  initialState: {
    account: {
      isLoading: true
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAccount.pending, (state) => {
      state.account.isLoading = true
    })
    builder.addCase(fetchAccount.fulfilled, (state,
      { payload: { email, access_granted: accessGranted } }) => {
      state.account = { email, accessGranted, isLoading: false }
    })
    builder.addCase(fetchAccount.rejected, (state) => {
      state.account.isLoading = false
    })
    builder.addCase(disconnectAccount.fulfilled, (state) => {
      state.account = { isLoading: false }
    })
    builder.addCase(disconnectAccount.rejected, (state) => {
      state.account.isLoading = false
    })
  }
})
